import eshopSafeCoating from "../assets/safe-coating1.webp";
import eshopSparePart from "../assets/spare-part1.webp";
import eshopPlaygroundEquip from "../assets/equip-2.webp";
import eshopOutdoorEquip from "../assets/equipments/outdoor-sport3.avif";
import eshopSmallArchitecture from "../assets/small-architecture1.webp";
import nordicLawn from "../assets/nordic-lawn-logo.png";
import kdf from "../assets/kdf-logo.png";
import denfitLogo from "../assets/denfit-logo.png";
import technix from "../assets/Technix.png";
import rubrig from "../assets/rubrig.webp";
import dipStationPdf from "../assets/equipments/dip_station/dip_station.pdf";
import parallelBarPdf from "../assets/equipments/parallel_bars/parallel_bars.pdf";
import parallelRailsPdf from "../assets/equipments/parallel_rails/parallel_rails.pdf";
import pullUpPdf from "../assets/equipments/pull_up/pull_up.pdf";
import chinUpPdf from "../assets/equipments/chip_up/chin_up.pdf";
import horizontalLadderPdf from "../assets/equipments/horizontal_ladder/horizontal_ladder.pdf";
import pushUpPdf from "../assets/equipments/push_up/push_up.pdf";
import denfitPdf from "../assets/equipments/denfit/denfit.pdf";
import singleSitUpPdf from "../assets/equipments/single_sit_up/single_sit_up.pdf";

import { EshopInterface } from "../types/Generic";
import {
  auto_smart_1,
  auto_smart_2,
  auto_smart_3,
  auto_smart_4,
  auto_smart_5,
  auto_smart_6,
  auto_smart_7,
  auto_smart_8,
  balanceSwingImg,
  benchesCoverImg,
  bicycleRackImg_1,
  bicycleRackImg_2,
  bicycleRackImg_3,
  carabinerImg_1,
  carabinerImg_2,
  carabinerImg_3,
  castingCoverImg,
  cellularImg_1,
  cellularImg_2,
  chin_up_1,
  chin_up_2,
  chin_up_3,
  cifN100Img_1,
  cifN102brImg_1,
  cifN102Img_1,
  cifN123brImg_1,
  cifN160brImg_1,
  concreteBenchesCoverImg,
  concreteN107brImg_1,
  concreteN107Img_1,
  concreteN115Img_1,
  concreteN131brImg_1,
  concreteN165Img_1,
  connectorCoverImg,
  crossConnectorImg_1,
  crossConnectorImg_2,
  denfitImg_1,
  denfitImg_10,
  denfitImg_11,
  denfitImg_12,
  denfitImg_2,
  denfitImg_3,
  denfitImg_4,
  denfitImg_5,
  denfitImg_6,
  denfitImg_7,
  denfitImg_8,
  denfitImg_9,
  dip_station_1,
  dip_station_2,
  dip_station_3,
  dip_station_4,
  fallProtectionImg,
  greenHybrid22Img,
  greenHybrid32Img,
  hdpeBroncoImg_1,
  hdpeBroncoImg_2,
  hdpeOptimaImg,
  horizontal_ladder_1,
  horizontal_ladder_2,
  horizontal_ladder_3,
  hybridCoverImg,
  iceRinksCoverImg,
  indoorCoatingImg_1,
  indoorCoatingImg_2,
  indoorCoatingImg_3,
  multi_ladder_1,
  multi_ladder_2,
  multi_ladder_3,
  multi_ladder_4,
  multi_ladder_5,
  multi_ladder_6,
  multi_ladder_7,
  multi_ladder_8,
  multiFuncHandleImg_1,
  multiFuncHandleImg_2,
  outdoorCoveringsImg_1,
  outdoorCoveringsImg_2,
  outdoorCoveringsImg_3,
  padsImg_1,
  padsImg_2,
  padsImg_3,
  padsImg_4,
  parallel_bars_1,
  parallel_bars_2,
  parallel_rails_1,
  parallel_rails_2,
  parallel_rails_3,
  partOfBalanceSwingCoverImg,
  pendulumImg,
  plasticCapsCoverImg,
  plasticPostCapImg_1,
  plasticPostCapImg_2,
  plasticPostCapImg_3,
  plasticPostCapImg_4,
  plasticPostCapImg_5,
  plasticScrewCapImg_1,
  plasticScrewCapImg_2,
  plasticScrewCapImg_3,
  plasticScrewCapImg_4,
  plasticScrewCapImg_5,
  pull_up_1,
  pull_up_2,
  pull_up_3,
  push_up_1,
  push_up_2,
  push_up_3,
  qs_1243_1,
  qs_1243_2,
  qs_1243_3,
  qs_1243_4,
  qs_1243_5,
  qs_1243_6,
  qs_1243_7,
  qs_1243_8,
  qs_50_1,
  qs_50_2,
  qs_50_3,
  qs_50_4,
  qs_50_5,
  qs_50_6,
  qs_50_7,
  qs_50_8,
  qs_50_9,
  reinForcedPolyCoverImg,
  reinforcedPolyRopeImg_1,
  reinforcedPolyRopeImg_2,
  reinforcedPolyRopeImg_3,
  round40lImg_1,
  round60lImg_1,
  round70lImg_1,
  rubberSwingSearForToddlersImg_1,
  rubberSwingSearForToddlersImg_2,
  rubberSwingSeatImg_1,
  rubberSwingSeatImg_2,
  seatForBalanceSwingImg_1,
  seatForBalanceSwingImg_2,
  sfN156brImg_1,
  sfN208brImg_1,
  sfN262Img_1,
  shockAbsurbingRubberImg_1,
  shockAbsurbingRubberImg_2,
  single_sit_up_1,
  single_sit_up_2,
  single_sit_up_3,
  springClovisImg_1,
  springClovisImg_2,
  springClovisImg_3,
  springClovisImg_4,
  square70lImg_1,
  stainlessStegImg_1,
  stainlessStegImg_2,
  stainlessStegImg_3,
  stainlessStegOnImg_1,
  stainlessStegOnImg_2,
  stainlessStegOnImg_3,
  stainlessStur1000_1,
  stainlessStur500_1,
  steelFrameBenchesCoverImg,
  swingHookImg_1,
  swingHookImg_2,
  swingSeatCoverImg,
  swingStorksNestImg_1,
  swingStorksNestImg_2,
  teeConnectorImg_1,
  teeConnectorImg_2,
  terra_house_simple_1,
  terra_house_simple_2,
  terra_house_simple_3,
  terra_house_simple_4,
  terra_house_simple_5,
  terra_house_simple_6,
  threeDAnimalImg_1,
  threeDAnimalImg_2,
  threeDAnimalImg_3,
  ticket_office_1,
  ticket_office_2,
  ticket_office_3,
  ticket_office_4,
  ticket_office_5,
  trashCansCoverImg,
} from "../assets";

import hags from "../assets/hags.png";
import playtop from "../assets/playtop.png";
import berliner from "../assets/berliner.png";
import novum from "../assets/novum.png";
import playtopNike from "../assets/playtop-nike.png";
import workImg1 from "../assets/work_completed/work-completed1.webp";
import workImg2 from "../assets/work_completed/work-completed2.webp";
import workImg3 from "../assets/work_completed/work-completed3.webp";
import workImg4 from "../assets/work_completed/work-completed4.webp";
import workImg5 from "../assets/work_completed/work-completed5.webp";
import workImg6 from "../assets/work_completed/work-completed6.webp";
import workImg7 from "../assets/work_completed/work-completed7.webp";
import workImg8 from "../assets/work_completed/work-completed8.webp";
import workImg9 from "../assets/work_completed/work-completed9.webp";
import workImg10 from "../assets/work_completed/work-completed10.webp";
import workImg11 from "../assets/work_completed/work-completed11.webp";
import workImg12 from "../assets/work_completed/work-completed12.webp";
import workImg13 from "../assets/work_completed/work-completed13.webp";
import workImg14 from "../assets/work_completed/work-completed14.webp";
import workImg15 from "../assets/work_completed/work-completed15.webp";
import workImg16 from "../assets/work_completed/work-completed16.webp";
import workImg17 from "../assets/work_completed/work-completed17.webp";
import workImg18 from "../assets/work_completed/work-completed18.webp";
import workImg19 from "../assets/work_completed/work-completed19.webp";
import workImg20 from "../assets/work_completed/work-completed20.webp";
import workImg21 from "../assets/work_completed/work-completed21.webp";
import workImg23 from "../assets/work_completed/work-completed23.webp";
import workImg24 from "../assets/work_completed/work-completed24.webp";
import workImg25 from "../assets/work_completed/work-completed25.webp";
import workImg26 from "../assets/work_completed/work-completed26.webp";
import workImg27 from "../assets/work_completed/work-completed27.webp";
import workImg28 from "../assets/work_completed/work-completed28.webp";
import workImg29 from "../assets/work_completed/work-completed29.webp";
import workImg30 from "../assets/work_completed/work-completed30.webp";
import workImg31 from "../assets/work_completed/work-completed31.webp";
import workImg32 from "../assets/work_completed/work-completed32.webp";
import workImg33 from "../assets/work_completed/work-completed33.webp";
import workImg34 from "../assets/work_completed/work-completed34.webp";
import workImg35 from "../assets/work_completed/work-completed35.webp";
import workImg36 from "../assets/work_completed/work-completed36.webp";
import workImg37 from "../assets/work_completed/work-completed37.webp";
import workImg38 from "../assets/work_completed/work-completed38.webp";
import workImg39 from "../assets/work_completed/work-completed39.webp";
import workImg40 from "../assets/work_completed/work-completed40.webp";
import workImg41 from "../assets/work_completed/work-completed41.webp";
import workImg42 from "../assets/work_completed/work-completed42.webp";
import workImg43 from "../assets/work_completed/work-completed43.webp";
import workImg44 from "../assets/work_completed/work-completed44.webp";
import workImg45 from "../assets/work_completed/work-completed45.webp";
import workImg46 from "../assets/work_completed/work-completed46.webp";
import workImg47 from "../assets/work_completed/work-completed47.webp";
import workImg48 from "../assets/work_completed/work-completed48.webp";
import workImg49 from "../assets/work_completed/work-completed49.webp";
import workImg50 from "../assets/work_completed/work-completed50.webp";
import workImg51 from "../assets/work_completed/work-completed51.webp";
import workImg52 from "../assets/work_completed/work-completed52.webp";
import workImgbefore from "../assets/equipments/before1.webp";

export const navItems = [
  {
    id: 1,
    text: "Products",
    path: "/products",
    hasDropdown: true,
    dropdownItems: [
      { id: 101, text: "Playgrounds", path: "/products/playgrounds" },
      { id: 102, text: "Outdoor Sports", path: "/products/outdoor-sports" },
      { id: 103, text: "Partners", path: "/products/partners" },
      { id: 104, text: "Portfolio", path: "/products/portfolio" },
    ],
  },
  {
    id: 2,
    text: "Services",
    path: "/services",
    hasDropdown: true,
    dropdownItems: [
      {
        id: 201,
        text: "Functional and Annual Control",
        path: "/services/functional-control",
      },
      { id: 202, text: "Equipment Sales", path: "/services/equipment-sales" },
      {
        id: 203,
        text: "Equipment Installation & Repair",
        path: "/services/equipment-installation-repair",
      },
      { id: 204, text: "Safe Coatings", path: "/services/safe-coatings" },
    ],
  },
  {
    id: 3,
    text: "E-shop",
    path: "/el-parduotuve",
    hasDropdown: true,
    dropdownItems: [
      { id: 301, text: "Equipment", path: "/e-shop/equipment" },
      { id: 302, text: "Safe Coatings", path: "/e-shop/safe-coatings" },
      { id: 303, text: "Spare Parts", path: "/e-shop/spare-parts" },
      {
        id: 304,
        text: "Small Architecture",
        path: "/e-shop/small-architecture",
      },
    ],
  },
  { id: 4, text: "Recent News Feeds", path: "/recents", hasDropdown: false },
];

export const workImages = [
  {
    images: [workImg1, workImg2, workImg3, workImg4, workImg5],
    desc: "galleryTranslate.denfit_fitness_equipment_caption",
  },
  {
    images: [workImg6, workImg7, workImg8, workImg9, workImg10],
    desc: "galleryTranslate.paneroal_street_jonava_caption",
  },
  {
    images: [
      workImg11,
      workImg12,
      workImgbefore,
      workImg13,
      workImg14,
      workImg15,
    ],
    desc: "galleryTranslate.renovation_of_children_playground_caption",
  },
  {
    images: [workImg16, workImg17, workImg18],
    desc: "galleryTranslate.denfit_exercise_machines_caption",
  },
  {
    images: [workImg19, workImg20, workImg21],
    desc: "galleryTranslate.peace_square_caption",
  },
  {
    images: [workImg23, workImg24, workImg25, workImg26],
    desc: "galleryTranslate.children_playground_in_jonava_caption",
  },
  {
    images: [workImg27, workImg28, workImg29, workImg30, workImg31, workImg32],
    desc: "galleryTranslate.refugee_reception_center_rukla_caption",
  },
  {
    images: [workImg33, workImg34, workImg35, workImg36, workImg37],
    desc: "galleryTranslate.basketball_court_installed_in_vilnius_caption",
  },
  {
    images: [
      workImg38,
      workImg39,
      workImg40,
      workImg41,
      workImg42,
      workImg43,
      workImg44,
    ],
    desc: "galleryTranslate.children_playground_on_mokyklos_caption",
  },
  {
    images: [workImg45, workImg46, workImg47, workImg48],
    desc: "galleryTranslate.children_playground_at_orlen_gas_caption",
  },
  {
    images: [workImg49, workImg50, workImg51, workImg52],
    desc: "galleryTranslate.children_playground_in_kaunas_caption",
  },
];

export const functionalControlAccordion = [
  {
    title: "services.functional_control_page_list1_title",
    items: [
      "services.functional_control_page_list1_item1",
      "services.functional_control_page_list1_item2",
      "services.functional_control_page_list1_item3",
      "services.functional_control_page_list1_item4",
      "services.functional_control_page_list1_item5",
      "services.functional_control_page_list1_item6",
      "services.functional_control_page_list1_item7",
      "services.functional_control_page_list1_item8",
      "services.functional_control_page_list1_item9",
      "services.functional_control_page_list1_item10",
      "services.functional_control_page_list1_item11",
      "services.functional_control_page_list1_item12",
      "services.functional_control_page_list1_item13",
    ],
  },
  {
    title: "services.functional_control_page_list2_title",
    items: [
      "services.functional_control_page_list2_item1",
      "services.functional_control_page_list2_item2",
      "services.functional_control_page_list2_item3",
      "services.functional_control_page_list2_item4",
      "services.functional_control_page_list2_item5",
      "services.functional_control_page_list2_item6",
      "services.functional_control_page_list2_item7",
      "services.functional_control_page_list2_item8",
      "services.functional_control_page_list2_item9",
      "services.functional_control_page_list2_item10",
    ],
  },
  {
    title: "services.functional_control_page_list3_title",
    items: [
      "services.functional_control_page_list3_item1",
      "services.functional_control_page_list3_item2",
      "services.functional_control_page_list3_item3",
      "services.functional_control_page_list3_item4",
    ],
  },
  {
    title: "services.functional_control_page_list4_title",
    items: ["services.functional_control_page_list4_item1"],
  },
];

export const eshopPageData: EshopInterface = {
  heading: "eshop.heading",
  description: "eshop.description",
  sections: [
    {
      type: "plain",
      bg: eshopPlaygroundEquip,
      title: "navTranslate.playgrounds",
      description: "products.playgrounds_page_description",
      desc: "eshop.equipment_desc",
      path: "/el-parduotuve/zaidimu-aiksteles",
      products: [
        {
          title: "eshop.playgrounds_product_title1",
          images: [pendulumImg],
          description: "eshop.playgrounds_product_desc1",
          specification: {
            height: "2.40 m",
            width: "1.40 m",
            length: "3.70 m",
            safetyZone: "26 m².",
          },
          partnersReference: [
            { logo: hags, path: "https://www.hags.com/home" },
          ],
        },
        {
          title: "eshop.playgrounds_product_title2",
          images: [
            springClovisImg_1,
            springClovisImg_2,
            springClovisImg_3,
            springClovisImg_4,
          ],
          description: "eshop.playgrounds_product_desc2",
          specification: {
            height: "0.59 m",
            width: "1 m",
            length: "1 m",
            safetyZone: "12.6 m²",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
        },
        {
          title: "eshop.playgrounds_product_title3",
          images: [balanceSwingImg],
          description: "eshop.playgrounds_product_desc3",
          specification: {
            height: "0.93 m",
            width: "0.28 m",
            length: "3.02 m",
            safetyZone: "10.6 m²",
            freeFallHeight: "0.85 m",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
            { path: "http://www.novum4kids.com/", logo: novum },
            {
              path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
              logo: berliner,
            },
            { path: "https://www.playtop.com/", logo: playtop },
            {
              path: "https://www.playtop.com/products/playtop-with-nike-grind",
              logo: playtopNike,
            },
          ],
        },
        {
          title: "eshop.playgrounds_product_title4",
          images: [
            qs_1243_1,
            qs_1243_2,
            qs_1243_3,
            qs_1243_4,
            qs_1243_5,
            qs_1243_6,
            qs_1243_7,
            qs_1243_8,
          ],
          description: "eshop.playgrounds_product_desc4",
          specification: {
            length: "6.59 m",
            width: "3.82 m",
            height: "3.61 m",
            areaOfSafetyZone: "52 m²",
            perimeterOfSafetyZone: "32 m",
            maximumFallHeight: "1.99 m",
            users: "13",
            userAge: "Min 3 - 14 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1uSlh9DlZiZsFVbiTLaIOCQct66MtGe4N/view",
        },
        {
          title: "eshop.playgrounds_product_title5",
          images: [
            qs_50_1,
            qs_50_2,
            qs_50_3,
            qs_50_4,
            qs_50_5,
            qs_50_6,
            qs_50_7,
            qs_50_8,
            qs_50_9,
          ],
          description: "eshop.playgrounds_product_desc5",
          specification: {
            length: "4.21 m",
            width: "4.54 m",
            height: "1.86 m",
            areaOfSafetyZone: "38 m²",
            perimeterOfSafetyZone: "26 m",
            maximumFallHeight: "1 m",
            users: "12",
            userAge: "Min 1 - 6 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1JPs-mX-auosOFtmQ948WsjWcGrkwt5YT/view",
        },
        {
          title: "eshop.playgrounds_product_title6",
          images: [
            ticket_office_1,
            ticket_office_2,
            ticket_office_3,
            ticket_office_4,
            ticket_office_5,
          ],
          description: "eshop.playgrounds_product_desc6",
          specification: {
            length: "1.95 m",
            width: "1.9 m",
            height: "1.72 m",
            areaOfSafetyZone: "22 m²",
            perimeterOfSafetyZone: "17 m",
            maximumFallHeight: "0.72 m",
            users: "10",
            userAge: "Min 1 - 14 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1TdUvii-IOAspRdD9pCXLj4VIj1K_yNYq/view",
        },
        {
          title: "eshop.playgrounds_product_title7",
          images: [
            auto_smart_1,
            auto_smart_2,
            auto_smart_3,
            auto_smart_4,
            auto_smart_5,
            auto_smart_6,
            auto_smart_7,
            auto_smart_8,
          ],
          description: "eshop.playgrounds_product_desc7",
          specification: {
            length: "2.18 m",
            width: "1.01 m",
            height: "1.32 m",
            areaOfSafetyZone: "19 m²",
            perimeterOfSafetyZone: "16 m",
            maximumFallHeight: "0.29 m",
            users: "6",
            userAge: "Min 3 - 14 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1C5BV34kGQgZeJnOKpjAfd_Z9kPjf7iRy/view",
        },
        {
          title: "eshop.playgrounds_product_title8",
          images: [
            multi_ladder_1,
            multi_ladder_2,
            multi_ladder_3,
            multi_ladder_4,
            multi_ladder_5,
            multi_ladder_6,
            multi_ladder_7,
            multi_ladder_8,
          ],
          description: "eshop.playgrounds_product_desc8",
          specification: {
            length: "3.02 m",
            width: "1.67 m",
            height: "2.46 m",
            areaOfSafetyZone: "38 m²",
            perimeterOfSafetyZone: "23 m",
            maximumFallHeight: "2.35 m",
            users: "12",
            userAge: "Min 3 - 14 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
          pdfLInk:
            "https://drive.google.com/file/d/1f4MmOcZ4AgieY5I5zD3d15nwSGXu-MJO/view",
        },
        {
          title: "eshop.playgrounds_product_title9",
          images: [
            terra_house_simple_1,
            terra_house_simple_2,
            terra_house_simple_3,
            terra_house_simple_4,
            terra_house_simple_5,
            terra_house_simple_6,
          ],
          description: "eshop.playgrounds_product_desc9",
          specification: {
            length: "1.41 m",
            width: "1.51 m",
            height: "1.79",
            areaOfSafetyZone: "18 m²",
            perimeterOfSafetyZone: "15.3 m",
            maximumFallHeight: "0.67 m",
            users: "4",
            userAge: "Min 1 - 5 Max",
          },
          partnersReference: [
            { path: "http://www.novum4kids.com/", logo: novum },
          ],
          price: "€1000 - €2000",
        },
      ],
    },
    {
      type: "plain",
      bg: eshopOutdoorEquip,
      title: "navTranslate.outdoor_sports",
      description: "products.outdoorsports_page_description",
      desc: "eshop.outdoorsports_desc",
      path: "/el-parduotuve/lauko-sportas",
      products: [
        {
          title: "eshop.outdoorsports_product_title1",
          images: [
            denfitImg_1,
            denfitImg_2,
            denfitImg_3,
            denfitImg_4,
            denfitImg_5,
            denfitImg_6,
            denfitImg_7,
            denfitImg_8,
            denfitImg_9,
            denfitImg_10,
            denfitImg_11,
            denfitImg_12,
          ],
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
            { path: "https://denfit.nl/", logo: denfitLogo },
          ],
          description: "eshop.outdoorsports_product_desc1",
          specification: {},
          pdfLInk: denfitPdf,
        },
        {
          title: "eshop.outdoorsports_product_title2",
          images: [dip_station_1, dip_station_2, dip_station_3, dip_station_4],
          description: "eshop.outdoorsports_product_desc2",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1940 mm",
            width: "610 mm",
            height: "800 mm",
            netWeight: "40,00 kg",
            volume: "0.25 m³",
            fallHeight: "800 mm",
            safetyAreaWidth: "3610 mm",
            safetyAreaLength: "4940 mm",
            safetyArea: "16 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: dipStationPdf,
        },
        {
          title: "eshop.outdoorsports_product_title3",
          images: [parallel_bars_1, parallel_bars_2],
          description: "eshop.outdoorsports_product_desc3",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "3540 mm",
            width: "670 mm",
            height: "950 mm",
            netWeight: "51,00 kg",
            volume: "0.66 m³",
            fallHeight: "950 mm",
            safetyAreaWidth: "3670 mm",
            safetyAreaLength: "6540 mm",
            safetyArea: "22 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: parallelBarPdf,
        },
        {
          title: "eshop.outdoorsports_product_title4",
          images: [
            horizontal_ladder_1,
            horizontal_ladder_2,
            horizontal_ladder_3,
          ],
          description: "eshop.outdoorsports_product_desc4",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "4060 mm",
            width: "810 mm",
            height: "2160 mm",
            netWeight: "70,00 kg",
            volume: "2.66 m³",
            fallHeight: "1150 mm",
            safetyAreaWidth: "3810 mm",
            safetyAreaLength: "7060 mm",
            safetyArea: "25 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: horizontalLadderPdf,
        },
        {
          title: "eshop.outdoorsports_product_title5",
          images: [single_sit_up_1, single_sit_up_2, single_sit_up_3],
          description: "eshop.outdoorsports_product_desc5",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1600 mm",
            width: "410 mm",
            height: "890 mm",
            netWeight: "35,00 kg",
            volume: "0.5 m³",
            fallHeight: "890 mm",
            safetyAreaWidth: "3410 mm",
            safetyAreaLength: "4600 mm",
            safetyArea: "14 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: singleSitUpPdf,
        },
        {
          title: "eshop.outdoorsports_product_title6",
          images: [chin_up_1, chin_up_2, chin_up_3],
          description: "eshop.outdoorsports_product_desc6",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1940 mm",
            width: "60 mm",
            height: "2620 mm",
            netWeight: "35,00 kg",
            volume: "0.87 m³",
            fallHeight: "1260 mm",
            safetyAreaWidth: "3060 mm",
            safetyAreaLength: "4940 mm",
            safetyArea: "14 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: chinUpPdf,
        },
        {
          title: "eshop.outdoorsports_product_title7",
          images: [parallel_rails_1, parallel_rails_2, parallel_rails_3],
          description: "eshop.outdoorsports_product_desc7",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1750 mm",
            width: "540 mm",
            height: "1740 mm",
            netWeight: "159,00 kg",
            volume: "2.73 m³",
            fallHeight: "1460 mm",
            safetyAreaWidth: "3540 mm",
            safetyAreaLength: "4750 mm",
            safetyArea: "15 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: parallelRailsPdf,
        },
        {
          title: "eshop.outdoorsports_product_title8",
          images: [push_up_1, push_up_2, push_up_3],
          description: "eshop.outdoorsports_product_desc8",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "2300 mm",
            width: "40 mm",
            height: "450 mm",
            netWeight: "23,00 kg",
            volume: "0.09 m³",
            fallHeight: "450 mm",
            safetyAreaWidth: "4400 mm",
            safetyAreaLength: "5300 mm",
            safetyArea: "22 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: pushUpPdf,
        },
        {
          title: "eshop.outdoorsports_product_title9",
          images: [pull_up_1, pull_up_2, pull_up_3],
          description: "eshop.outdoorsports_product_desc9",
          specification: {
            ageRange: "14+",
            assemblyTime: "3 hours",
            length: "1290 mm",
            width: "920 mm",
            height: "2260 mm",
            netWeight: "84,00 kg",
            volume: "3.54 m³",
            fallHeight: "870 mm",
            safetyAreaWidth: "3920 mm",
            safetyAreaLength: "4300 mm",
            safetyArea: "15 m²",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
          ],
          price: "€1000 - €2000",
          pdfLInk: pullUpPdf,
        },
      ],
    },
    {
      type: "categorized",
      bg: eshopSparePart,
      title: "navTranslate.spare_parts",
      desc: "eshop.spare_parts_desc",
      description: "products.spare_parts_page_description",
      path: "/el-parduotuve/atsargines-dalys",
      subCategories: [
        {
          type: "plain",
          bg: iceRinksCoverImg,
          title: "eshop.ice_rinks",
          description: "data not available.",
          path: "/el-parduotuve/atsargines-dalys/ice-rinks",
          products: [
            {
              images: [hdpeOptimaImg],
              title: "eshop.spare_part_ice_rinks_product_title1",
              description: "eshop.spare_part_ice_rinks_product_desc1",
              specification: {
                platformHeight: "1500 mm",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [stainlessStur1000_1],
              title: "eshop.spare_part_ice_rinks_product_title2",
              description: "eshop.spare_part_ice_rinks_product_desc2",
              specification: {
                platformHeight: "1000 mm / 1250 mm / 1500 mm",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [stainlessStur500_1],
              title: "eshop.spare_part_ice_rinks_product_title3",
              description: "eshop.spare_part_ice_rinks_product_desc3",
              specification: {
                platformHeight:
                  "1000 mm / 1250 mm / 1500 mm / 2000 mm / 2500 mm;",
                dimensions: "2385 / 2760 / 3182 / 4035 / 4885 x 540 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [
                stainlessStegImg_1,
                stainlessStegImg_2,
                stainlessStegImg_3,
              ],
              title: "eshop.spare_part_ice_rinks_product_title4",
              description: "eshop.spare_part_ice_rinks_product_desc4",
              specification: {
                platformHeight: "1000 mm / 1250 mm / 1500 mm; ",
                dimensions: "2070 / 2291 / 2716 x 548 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [
                stainlessStegOnImg_1,
                stainlessStegOnImg_2,
                stainlessStegOnImg_3,
              ],
              title: "eshop.spare_part_ice_rinks_product_title5",
              description: "eshop.spare_part_ice_rinks_product_desc5",
              specification: {
                platformHeight:
                  "600 mm / 1000 mm / 1250 mm / 1500 mm / 2000 mm / 2500 mm; ",
                dimensions: "1470/ 2152/ 2373/ 2799/ 3649/ 4500 x 548 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              images: [hdpeBroncoImg_1, hdpeBroncoImg_2],
              title: "eshop.spare_part_ice_rinks_product_title6",
              description: "eshop.spare_part_ice_rinks_product_desc6",
              specification: {
                dimensions: "2422 / 3273 x 580 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
        },
        {
          type: "plain",
          bg: swingSeatCoverImg,
          title: "eshop.swing_seats",
          description: "Information not available",
          path: "/el-parduotuve/atsargines-dalys/swing-seats",
          products: [
            {
              title: "eshop.spare_part_swing_seats_product_title1",
              images: [swingStorksNestImg_1, swingStorksNestImg_2],
              description: "eshop.spare_part_swing_seats_product_desc1",
              specification: {
                dimensions: "Ø 1200 / Ø 1000 x 120 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "eshop.spare_part_swing_seats_product_title2",
              images: [
                rubberSwingSearForToddlersImg_1,
                rubberSwingSearForToddlersImg_2,
              ],
              description: "eshop.spare_part_swing_seats_product_desc2",
              specification: {
                dimensions:
                  "For children up to 36 months -- 450 x 315 x 230 mm.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "eshop.spare_part_swing_seats_product_title3",
              images: [rubberSwingSeatImg_1, rubberSwingSeatImg_2],
              description: "eshop.spare_part_swing_seats_product_desc3",
              specification: {
                dimensions: "450 x 180 x 38.5 mm",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
        },
        {
          type: "categorized",
          bg: reinForcedPolyCoverImg,
          title: "eshop.repair_parts",
          description: "eshop.repair_parts_description",
          path: "/el-parduotuve/atsargines-dalys/repair-parts",
          products: [
            {
              title: "eshop.spare_part_reinforced_product_title",
              images: [
                reinforcedPolyRopeImg_1,
                reinforcedPolyRopeImg_2,
                reinforcedPolyRopeImg_3,
              ],
              description: "eshop.spare_part_reinforced_product_desc",
              specification: {
                dimensions: "Ø 16 mm x 220 m.",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
          subCategories: [
            {
              type: "plain",
              bg: plasticCapsCoverImg,
              title: "eshop.plastic_caps",
              path: "/el-parduotuve/atsargines-dalys/repair-parts/plastic-caps",
              products: [
                {
                  title: "eshop.spare_part_plastic_caps_product_title1",
                  images: [
                    plasticScrewCapImg_1,
                    plasticScrewCapImg_2,
                    plasticScrewCapImg_3,
                    plasticScrewCapImg_4,
                    plasticScrewCapImg_5,
                  ],
                  description: "eshop.spare_part_plastic_caps_product_desc2",
                  specification: {},
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "eshop.spare_part_plastic_caps_product_title2",
                  images: [
                    plasticPostCapImg_1,
                    plasticPostCapImg_2,
                    plasticPostCapImg_3,
                    plasticPostCapImg_4,
                    plasticPostCapImg_5,
                  ],
                  description: "eshop.spare_part_plastic_caps_product_desc2",
                  specification: {
                    dimensions:
                      "For which plastic post caps are available: Round timber: Ø 80 / 100 / 120 / 140 mm.  Square timber: 70 x 70 / 90 x 90 / 100 x 100 / 120 x 120 mm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
            {
              type: "plain",
              bg: connectorCoverImg,
              title: "eshop.connectors",
              path: "/el-parduotuve/atsargines-dalys/repair-parts/connectors",
              products: [
                {
                  title: "eshop.spare_part_cross_connector_title",
                  images: [crossConnectorImg_1, crossConnectorImg_2],
                  description: "eshop.spare_part_cross_connector_desc",
                  specification: {
                    dimensions: "38 x 50 x 33.5 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "eshop.spare_part_tee_connector_title",
                  images: [teeConnectorImg_1, teeConnectorImg_2],
                  description: "eshop.spare_part_tee_connector_desc",
                  specification: {},
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
            {
              type: "plain",
              bg: partOfBalanceSwingCoverImg,
              title: "eshop.parts_of_balance_swings",
              path: "/el-parduotuve/atsargines-dalys/repair-parts/parts-of-balance-swings",
              products: [
                {
                  title: "eshop.spare_part_shock_absorbing_rubber_title",
                  images: [
                    shockAbsurbingRubberImg_1,
                    shockAbsurbingRubberImg_2,
                  ],
                  description: "eshop.spare_part_shock_absorbing_rubber_desc",
                  specification: {
                    dimensions: "150 x 150 x 80 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "eshop.spare_part_seat_for_balance_swing_title",
                  images: [seatForBalanceSwingImg_1, seatForBalanceSwingImg_2],
                  description: "eshop.spare_part_seat_for_balance_swing_desc",
                  specification: {
                    dimensions: "290 x 235 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "eshop.spare_part_multifunctional_handle_title",
                  images: [multiFuncHandleImg_1, multiFuncHandleImg_2],
                  description: "eshop.spare_part_multifunctional_handle_desc",
                  specification: {
                    dimensions: "185 x 175 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "eshop.spare_part_carabiners_title",
                  images: [carabinerImg_1, carabinerImg_2, carabinerImg_3],
                  description: "eshop.spare_part_carabiners_desc",
                  specification: {
                    dimensions:
                      "Galvanized steel: Stainless steel: - 23 x 12 mm; - 23 x 12 mm; - 20 x 16 mm; - 18 x 12 mm. - 20 x 8 mm; - 18 x 12 mm; - 33 x 19 mm.",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title: "eshop.spare_part_swing_hook_premium_title",
                  images: [swingHookImg_1, swingHookImg_2],
                  description: "eshop.spare_part_swing_hook_premium_desc",
                  specification: {
                    dimensions: "265 x 62 x 40 mm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "categorized",
      bg: eshopSafeCoating,
      title: "navTranslate.safe_coatings",
      description: "eshop.safe_coatings_description",
      desc: "eshop.safe_coatings_desc",
      path: "/el-parduotuve/saugios-dangos",
      products: [
        {
          title: "eshop.safe_coatings_product_title1",
          images: [cellularImg_1, cellularImg_2],
          description: "eshop.safe_coatings_product_desc1",
          specification: {},
          partnersReference: [
            { logo: technix, path: "https://technix-rubber.com" },
          ],
        },
        {
          title: "eshop.safe_coatings_product_title2",
          images: [padsImg_1, padsImg_2, padsImg_3, padsImg_4],
          description: "eshop.safe_coatings_product_desc2",
          specification: {},
          partnersReference: [{ logo: rubrig, path: "https://rubrig.com" }],
        },
      ],
      subCategories: [
        {
          type: "plain",
          bg: hybridCoverImg,
          title: "eshop.hybrid_coatings",
          path: "/el-parduotuve/saugios-dangos/hybrid-coatings",
          products: [
            {
              images: [greenHybrid22Img],
              title: "eshop.safe_coatings_hybrid_product_title1",
              description: "eshop.safe_coatings_hybrid_product_desc2",
              specification: {},
              partnersReference: [
                { logo: nordicLawn, path: "https://nordiclawn.com/da/" },
              ],
            },
            {
              title: "eshop.safe_coatings_hybrid_product_title2",
              images: [greenHybrid32Img],
              description: "eshop.safe_coatings_hybrid_product_desc2",
              specification: {},
              partnersReference: [
                { logo: nordicLawn, path: "https://nordiclawn.com/da/" },
              ],
            },
            {
              title: "eshop.safe_coatings_hybrid_product_title3",
              images: [fallProtectionImg],
              description: "eshop.safe_coatings_hybrid_product_desc3",
              specification: {},
              partnersReference: [
                { logo: nordicLawn, path: "https://nordiclawn.com/da/" },
              ],
            },
          ],
        },
        {
          type: "plain",
          bg: castingCoverImg,
          title: "eshop.castable_coatings",
          path: "/el-parduotuve/saugios-dangos/castable-coatings",
          products: [
            {
              title: "eshop.safe_coatings_castable_product_title1",
              images: [
                indoorCoatingImg_1,
                indoorCoatingImg_2,
                indoorCoatingImg_3,
              ],
              description: "eshop.safe_coatings_castable_product_desc1",
              specification: {},
              partnersReference: [
                { logo: kdf, path: "https://www.kdf.gr/en/" },
                { logo: playtop, path: "https://www.playtop.com" },
              ],
            },
            {
              title: "eshop.safe_coatings_castable_product_title2",
              images: [
                outdoorCoveringsImg_1,
                outdoorCoveringsImg_2,
                outdoorCoveringsImg_3,
              ],
              description: "eshop.safe_coatings_castable_product_desc2",
              specification: {},
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "eshop.safe_coatings_castable_product_title3",
              images: [threeDAnimalImg_1, threeDAnimalImg_2, threeDAnimalImg_3],
              description: "eshop.safe_coatings_castable_product_desc3",
              specification: {},
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "categorized",
      bg: eshopSmallArchitecture,
      title: "navTranslate.small_architecture",
      description: "eshop.small_architecture_description",
      desc: "eshop.small_architecture_desc",
      path: "/el-parduotuve/mazoji-architektura",
      products: [
        {
          title: "eshop.bicycle_racks",
          images: [bicycleRackImg_1, bicycleRackImg_2, bicycleRackImg_3],
          description: "Information not available",
          specification: {
            height: "0.55 m",
            width: "0.14 m",
            length: "2 m",
          },
          partnersReference: [
            { path: "http://www.hags.com/en-us/home", logo: hags },
            { path: "http://www.novum4kids.com/", logo: novum },
            {
              path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
              logo: berliner,
            },
            { path: "https://www.playtop.com/", logo: playtop },
            {
              path: "https://www.playtop.com/products/playtop-with-nike-grind",
              logo: playtopNike,
            },
          ],
        },
      ],
      subCategories: [
        {
          type: "plain",
          bg: trashCansCoverImg,
          title: "eshop.trash_cans",
          description: "Information not available",
          desc: "Concrete trash cans with natural granite finish; made of Portland cement",
          path: "/el-parduotuve/mazoji-architektura/trash-cans",
          products: [
            {
              title: "eshop.small_architecture_trash_cans_round_40l",
              images: [round40lImg_1],
              description: "eshop.small_architecture_trash_cans_round_40l_desc",
              specification: {
                height: "62 cm",
                bottomDiameter: "52cm",
                topDiameter: "45 cm",
                weight: "130 kg",
                boxCapacity: "50 l",
                boxCapacityWithInsert: "40 l",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "eshop.small_architecture_trash_cans_round_60l",
              images: [round60lImg_1],
              description: "eshop.small_architecture_trash_cans_round_60l_desc",
              specification: {
                height: "81 cm",
                diameter: "62.5 cm",
                weight: "320 kg",
                boxCapacity: "75 l",
                boxCapacityWithInsert: "60 l",
                boxCapacityWithLid: "55l",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "eshop.small_architecture_trash_cans_round_70l",
              images: [round70lImg_1],
              description: "eshop.small_architecture_trash_cans_round_70l_desc",
              specification: {
                height: "72 cm",
                diameter: "53 cm",
                weight: "180 kg",
                boxCapacity: "80 l",
                boxCapacityWithInsert: "70 l",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
            {
              title: "eshop.small_architecture_trash_cans_square_70l",
              images: [square70lImg_1],
              description:
                "eshop.small_architecture_trash_cans_square_70l_desc",
              specification: {
                height: "80 cm",
                bottom: "45 cm x 45 cm",
                weight: "175 kg",
                boxCapacity: "70 l",
              },
              partnersReference: [
                { path: "http://www.hags.com/en-us/home", logo: hags },
                { path: "http://www.novum4kids.com/", logo: novum },
                {
                  path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                  logo: berliner,
                },
                { path: "https://www.playtop.com/", logo: playtop },
                {
                  path: "https://www.playtop.com/products/playtop-with-nike-grind",
                  logo: playtopNike,
                },
              ],
            },
          ],
        },
        {
          type: "categorized",
          bg: benchesCoverImg,
          title: "eshop.benches",
          description: "eshop.benches_description",
          desc: "Benches, trash cans",
          path: "/el-parduotuve/mazoji-architektura/benches",
          subCategories: [
            {
              type: "plain",
              bg: concreteBenchesCoverImg,
              title: "eshop.concrete_benches",
              desc: "Concrete benches with natural granite finish; made of Portland cement. Seat – 10 cm wide and 4 cm thick alder or ash wood slats, painted 3 times with modern, environmentally friendly varnish. Steel seat parts, galvanized and powder-coated",
              path: "/el-parduotuve/mazoji-architektura/benches/concrete-benches",
              products: [
                {
                  title:
                    "eshop.small_architecture_concrete_brench_without_backrest_NO107",
                  images: [concreteN107Img_1],
                  description:
                    "eshop.small_architecture_concrete_brench_without_backrest_NO107_desc",
                  specification: {
                    height: "44 cm",
                    totalLength: "210 cm",
                    lengthOfWoodenPart: "180 cm",
                    width: "40 cm",
                    weight: "180 kg",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_concrete_brench_with_backrest_NO107",
                  images: [concreteN107brImg_1],
                  description:
                    "eshop.small_architecture_concrete_brench_with_backrest_NO107_desc",
                  specification: {
                    seatHeight: "44 cm",
                    totalHeight: "78 cm",
                    totalLength: "210 cm",
                    lengthOfWoodenPart: "180 cm",
                    width: "40 cm",
                    weight: "200 kg",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_concrete_brench_with_backrest_NO131",
                  images: [concreteN131brImg_1],
                  description:
                    "eshop.small_architecture_concrete_brench_with_backrest_NO131_desc",
                  specification: {
                    seatHeight: "44 cm",
                    totalHeight: "77 cm",
                    lengthOfWoodenPart: "180 cm",
                    seatWidth: "40 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_concrete_brench_without_backrest_NO165",
                  images: [concreteN165Img_1],
                  description:
                    "eshop.small_architecture_concrete_brench_without_backrest_NO165_desc",
                  specification: {
                    height: "42 cm",
                    lengthOfWoodenPart: "191.5 cm",
                    seatWidth: "37.5 cm",
                    weight: "140 kg",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_concrete_brench_without_backrest_NO115",
                  images: [concreteN115Img_1],
                  description:
                    "eshop.small_architecture_concrete_brench_without_backrest_NO115_desc",
                  specification: {
                    height: "44 cm",
                    length: "4 x 180 cm ",
                    seatWidth: "41 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
            {
              type: "plain",
              bg: steelFrameBenchesCoverImg,
              title: "eshop.steel_frame_benches",
              desc: "The seat is made of 4 cm thick wooden slats, painted 3 times with a modern, environmentally friendly varnish. The bench frame is made of galvanized steel sheet and powder coated",
              path: "/el-parduotuve/mazoji-architektura/benches/steel-frame-benches",
              products: [
                {
                  title:
                    "eshop.small_architecture_steel_frame_brench_with_backrest_NO156",
                  images: [sfN156brImg_1],
                  description:
                    "eshop.small_architecture_steel_frame_brench_with_backrest_NO156_desc",
                  specification: {
                    height: "43 cm",
                    totalHeight: "76 cm",
                    totalLength: "205 cm",
                    lengthOfWoodenPart: "180 cm",
                    width: "45 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_steel_frame_brench_with_backrest_NO208",
                  images: [sfN208brImg_1],
                  description:
                    "eshop.small_architecture_steel_frame_brench_with_backrest_NO208_desc",
                  specification: {
                    height: "45 cm",
                    totalHeight: "79 cm",
                    totalLength: "180 cm",
                    width: "55 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_steel_frame_brench_without_backrest_NO262",
                  images: [sfN262Img_1],
                  description:
                    "eshop.small_architecture_steel_frame_brench_without_backrest_NO262_desc",
                  specification: {
                    height: "45 cm",
                    totalHeight: "79 cm",
                    totalLength: "180 cm",
                    width: "55 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
            {
              type: "plain",
              bg: castingCoverImg,
              title: "eshop.cast_iron_frame_benches",
              desc: "The seat is made of 4 cm thick wooden slats, painted 3 times with a modern, environmentally friendly varnish. The base is cast iron, coated with primer and top coat",
              path: "/el-parduotuve/mazoji-architektura/benches/cast-iron-frame-benches",
              products: [
                {
                  title:
                    "eshop.small_architecture_cast_iron_frame_brench_with_backrest_NO123",
                  images: [cifN123brImg_1],
                  description:
                    "eshop.small_architecture_cast_iron_frame_brench_with_backrest_NO123_desc",
                  specification: {
                    height: "42 cm",
                    totalHeight: "74 cm",
                    totalLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_cast_iron_frame_brench_with_backrest_NO102",
                  images: [cifN102brImg_1],
                  description:
                    "eshop.small_architecture_cast_iron_frame_brench_with_backrest_NO102",
                  specification: {
                    height: "41 cm",
                    totalHeight: "70 cm",
                    totalLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_cast_iron_frame_brench_without_backrest_NO102",
                  images: [cifN102Img_1],
                  description:
                    "eshop.small_architecture_cast_iron_frame_brench_without_backrest_NO102_desc",
                  specification: {
                    height: "42 cm",
                    width: "58 cm",
                    totalLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_cast_iron_frame_brench_without_backrest_NO100",
                  images: [cifN100Img_1],
                  description:
                    "eshop.small_architecture_cast_iron_frame_brench_without_backrest_NO100_desc",
                  specification: {
                    height: "42 cm",
                    width: "58 cm",
                    totalLength: "230 cm",
                    seatLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
                {
                  title:
                    "eshop.small_architecture_cast_iron_frame_brench_with_backrest_NO160",
                  images: [cifN160brImg_1],
                  description:
                    "eshop.small_architecture_cast_iron_frame_brench_with_backrest_NO160",
                  specification: {
                    height: "43 cm",
                    totalHeight: "75 cm",
                    totalLength: "180 cm",
                  },
                  partnersReference: [
                    { path: "http://www.hags.com/en-us/home", logo: hags },
                    { path: "http://www.novum4kids.com/", logo: novum },
                    {
                      path: "https://berliner-playequipment.com/us/playground-and-play-equipment/",
                      logo: berliner,
                    },
                    { path: "https://www.playtop.com/", logo: playtop },
                    {
                      path: "https://www.playtop.com/products/playtop-with-nike-grind",
                      logo: playtopNike,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
